import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "components/loader";
import { useGetInTouchLocation } from "hooks/Forms/useGetInTouchLocation";
import ThankYouPopup from "components/popup/thankYouPopup";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import icon1 from "assets/new-assets/icon_1.svg";
import icon2 from "assets/new-assets/icon_2.svg";
import icon3 from "assets/new-assets/95Business.svg";
import formCommonPostData from "utils/form-common-post-data";
import {
  errorMessage,
  errorMessageEmail,
  patternEmail,
} from "utils/form-validation";

export default function LocationBanner({
  title,
  content,
  backgroundCol,
  formOrangeHead,
  formWhiteHead,
  p,
  bName,
}) {
  const [open, setOpen] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const location = useLocation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { status, mutateAsync } = useGetInTouchLocation();

  const onSubmit = (data) => {
    const postData1 = {
      name: data.name,
      email: data.email,
      message: data.message,
      pagelink: location.href,
      consent: data.consent,
    };
    const postData = { ...postData1, ...formCommonPostData() };
    mutateAsync(postData).then((_) => {
      reset();
      setOpen(true);
    });
  };

  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();
    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    }, []);
    return variant;
  };
  // const variant = 1;
  const variant = useExperiment("_b1eORemTP6uefA63zaTlQ");

  return (
    <div
      className={`${
        backgroundCol ? backgroundCol : "bg-location-banner"
      } bg-cover bg-no-repeat bg-center flex items-center justify-center`}
    >
      <div className="mainContainer w-[90%] 2xl:w-[65%] 3xl:min-w-[80%] 4xl:min-w-[65%] flex flex-wrap lg:flex-nowrap  justify-between 2xl:justify-between xl:justify-around items-center text-white pt-5 pb-[60px] px-6 2xl:px-6 2xl:ml-0">
        <div className="textContent text-white md:w-11/12 lg:w-7/12 w-full flex flex-col ">
          <div className="text">
            <h1
              className="text-40 leading-[50px] font-secondary font-bold mb-[1.5rem]  max-w-[545px]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p className="mb-[1.5rem] font-opensans leading-[1.6] max-w-[545px]">
              {content}
            </p>
          </div>
          <div className="btn">
            <Link
              to="/quote"
              className="bg-orange hover:bg-hoverYellow rounded-3xl w-[180px] flex items-center justify-center h-[40px] font-semibold text-sm font-opensans"
            >
              {variant == "1"
                ? "START TRANSLATION"
                : bName
                ? bName
                : "TRANSLATE NOW"}
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3  py-10 gap-y-5  sm:pt-20 sm:gap-y-6 font-opensans text-md">
            <div className="flex flex-row ">
              <img className="w-[22px] h-[24px] mr-2" src={icon1} alt={icon1} />
              <p className="ml-1">
                1 Year Guarantee
                <span className="sm:inline hidden">&nbsp; &nbsp; |</span>
              </p>
            </div>
            <div className="flex flex-row ">
              <img className="w-[22px] h-[24px] mr-2" src={icon2} alt={icon2} />
              <p className="ml-1">
                24/7 Availability
                <span className="sm:inline hidden">&nbsp; &nbsp; &nbsp; |</span>
              </p>
            </div>
            <div className="flex flex-row ">
              <img className="w-[22px] h-[24px] mr-2" src={icon3} alt={icon3} />
              <p className="ml-1 whitespace-nowrap">
                95,000 Business Customers
              </p>
            </div>
            <div className="flex flex-row sm:w-max ">
              <div className="flex sm:flex-row flex-col">
                <img
                  className="w-[22px] h-[24px] mr-2"
                  src="https://tomedes.gumlet.io/assets/clients/ISO.svg"
                  alt=""
                />
                <p className="ml-1 sm:block hidden">
                  ISO Certifications for Enhanced Translation Quality
                </p>
              </div>
              <p className="ml-1 sm:hidden block">
                ISO Certifications for <br /> Enhanced Translation Quality
              </p>
            </div>
          </div>
          {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-0 lg:gap-2 xl:gap-0 mt-5 font-opensans text-md">
              <div className="flex flex-row">
                <img
                  className="w-4 mr-2"
                  src="https://tomedes.gumlet.io/frontend/images/location-template/badge.svg"
                  alt=""
                />
                <p className="ml-1">1 Year Guarantee |</p>
              </div>
              <div className="flex flex-row">
                <img
                  className="w-[22px] mr-2"
                  src="https://tomedes.gumlet.io/frontend/images/location-template/call-center.svg"
                  alt=""
                />
                <p className="ml-1">24/7 Availability |</p>
              </div>
              <div className="flex flex-row">
                <img
                  className="w-[22px] mr-2"
                  src="https://tomedes.gumlet.io/frontend/images/location-template/16-express.svg"
                  alt=""
                />
                <p className="ml-1 ">Fast Delivery</p>
              </div>
            </div> */}
        </div>
        <ThankYouPopup open={open} setOpen={setOpen} />
        <div className="form border-white bg-locationFormBorder  justify-center min-h-[415px] xl:min-h-[443px]  max-w-[380px] min-w-300 py-4 xl:py-8  px-6 mt-4 ml-0 2xl:mr-[69px] ">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="inputs flex flex-col mx-auto justify-center text-black  max-w-max">
              <h2 className="text-2xl font-bold pb-4 font-secondary 2xl:mt-[14px]">
                <span className="text-orange">{formOrangeHead}</span>{" "}
                {formWhiteHead}
              </h2>
              <p className=" font-opensans pb-4 mb-[10px]">
                {p ? p : "Get in touch with us in real-time, any time."}
              </p>
              <input
                type="text"
                placeholder="Name"
                name="name"
                className={`${
                  errors.name ? "border-red" : "border-borderGray"
                } outline-none font-opensans border  rounded pl-3 py-1 mb-5`}
                {...register("name", {
                  required: true,
                })}
              />
              {errors.name && (
                <span className="text-red text-sm font-primary mb-[10px] mt-[-16px]">
                 {errorMessage}
                </span>
              )}
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                className={`${
                  errors.email ? "border-red" : "border-borderGray"
                } font-opensans outline-none border rounded pl-3 py-1 mb-5`}
                {...register("email", {
                  required: true,
                  pattern: patternEmail,
                })}
              />
              {errors.email && (
                <span className="text-red text-sm font-primary  mb-[10px] mt-[-16px]">
                 {errorMessageEmail}
                </span>
              )}
              <textarea
                className={`${
                  errors.message ? "border-red" : "border-borderGray"
                } font-opensans outline-none border rounded  pl-3 py-1 mb-5`}
                name="message"
                cols="30"
                rows="2"
                placeholder="Tell us more about your needs"
                {...register("message")}
              ></textarea>
              {errors.message && (
                <span className="text-red text-sm font-primary mb-[10px] mt-[-16px]">
                 {errorMessage}
                </span>
              )}
              <div className="mb-5">
                <div className="flex items-baseline gap-2">
                  {/* <input
                      type="checkbox"
                      name="consent"
                      id="consent"
                      {...register("consent", {
                      })}
                      onChange={() => setCheckBox((value) => !value)}
                    /> */}
                  <p className="text-sm text-black font-opensans">
                    *I agree to Tomedes'&nbsp;
                    <Link
                      to="/privacy"
                      className="text-orange hover:text-newOrange-100 underline transition-colors"
                    >
                      Privacy Policy
                    </Link>
                    &nbsp;by submitting this form.
                  </p>
                </div>
                {/* {errors.privacy_policy && (
                    <span className="text-red text-sm font-primary mb-[10px] mt-[-16px]">
                      Please tick above to agree terms & conditions
                    </span>
                  )} */}
              </div>
              <input type="hidden" id="zc_gad" name="zc_gad" value="" />
              <button
                type="submit"
                className="bg-orange py-2 text-center font-secondary font-extrabold  text-white bannerform_submit"
              >
                {status === "loading" ? <Loader /> : "SUBMIT"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
